import PropTypes from 'prop-types';
import Card from './Card';
import Button from './Button';

/**
 * PricingCard - Pricing plan card component
 * 
 * Features:
 * - Popular badge for highlighted plans
 * - Feature list with checkmarks
 * - CTA button at bottom
 * - Uses Card and Button components
 * 
 * Used for: Pricing page
 */
const PricingCard = ({
  name,
  price,
  period = 'ay',
  features = [],
  isPopular = false,
  onSelect,
  buttonText = 'Hemen Başla',
}) => {
  return (
    <div className="relative">
      {/* Popular Badge */}
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
          <span className="bg-primary-500 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-lg">
            En Popüler
          </span>
        </div>
      )}

      {/* Card with conditional highlight */}
      <Card
        className={`p-8 ${
          isPopular
            ? 'border-2 border-primary-500 shadow-xl'
            : 'border border-gray-200'
        }`}
        hoverable
      >
        {/* Plan Name */}
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{name}</h3>

        {/* Price */}
        <div className="mb-6">
          <span className="text-4xl font-bold text-gray-900">₺{price}</span>
          <span className="text-gray-600 text-lg ml-2">/ {period}</span>
        </div>

        {/* Features List */}
        <ul className="space-y-4 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              {/* Checkmark Icon */}
              <svg
                className="w-6 h-6 text-primary-500 flex-shrink-0 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-gray-600 text-base">{feature}</span>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <Button
          variant={isPopular ? 'primary' : 'outline'}
          size="lg"
          onClick={onSelect}
          className="w-full"
        >
          {buttonText}
        </Button>
      </Card>
    </div>
  );
};

PricingCard.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  period: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  isPopular: PropTypes.bool,
  onSelect: PropTypes.func,
  buttonText: PropTypes.string,
};

export default PricingCard;

